// src/pages/BlogList.jsx
import React, { useEffect, useState } from "react";
import { fetchBlogs } from "../services/BlogService";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Blog.css";

export default function BlogList() {
  const [rows, setRows] = useState([]);
  const [page,setPage] = useState(1);
  const [pages,setPages] = useState(1);
  const [q,setQ] = useState("");

  const load = async (p=1) => {
    const data = await fetchBlogs({ page:p, limit:9, q });
    setRows(data.rows || []); setPage(data.page||p); setPages(data.pages||1);
  };

  useEffect(()=>{ load(); }, []); // eslint-disable-line

  return (
    <div className="blog-page">
      <div className="blog-hero">
        <motion.h1 initial={{opacity:0,y:10}} animate={{opacity:1,y:0}}>Roupan Naturals — Articles & Recipes</motion.h1>
        <p className="lead">Discover tips, DIYs, and stories about natural wellness.</p>
      </div>

      <div className="container py-4">
        <div className="d-flex gap-2 mb-3">
          <input className="form-control" placeholder="Search blogs..." value={q} onChange={e=>setQ(e.target.value)} />
          <button className="btn btn-primary" onClick={()=>load(1)}>Search</button>
        </div>

        <div className="row g-4">
          {rows.map(b => (
            <div className="col-md-4" key={b.id}>
              <motion.div whileHover={{scale:1.02}} className="card blog-card h-100">
                {b.mediaUrl && (/\.(mp4|webm|ogg)$/i.test(b.mediaUrl) ? (
                  <video src={b.mediaUrl} className="card-img-top" controls />
                ) : (
                  <img src={b.mediaUrl} className="card-img-top" alt={b.title} />
                ))}
                <div className="card-body">
                  <h5 className="card-title">{b.title}</h5>
                  <p className="card-text text-muted">{b.excerpt}</p>
                  <Link to={`/blogs/${b.slug}`} className="stretched-link">Read more →</Link>
                </div>
              </motion.div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between align-items-center mt-4">
          <div>Page {page} / {pages}</div>
          <div>
            <button className="btn btn-outline-secondary me-2" disabled={page<=1} onClick={()=>load(page-1)}>Prev</button>
            <button className="btn btn-outline-secondary" disabled={page>=pages} onClick={()=>load(page+1)}>Next</button>
          </div>
        </div>
      </div>
    </div>
  );
}
